// client/src/services/poaAiAssist.ts
// Service layer for the POA AI Assist chat endpoint.

export interface AiMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AiTextResponse {
  type: 'message';
  text: string;
}

export interface AiFormResponse {
  type: 'form';
  payload: Record<string, unknown>;
  message: string;
}

export type AiResponse = AiTextResponse | AiFormResponse;

export async function sendAiAssistMessage(messages: AiMessage[]): Promise<AiResponse> {
  const res = await fetch('/api/poa-ai-assist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ messages }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `AI request failed (${res.status})`);
  }

  return res.json();
}
